import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../contexts/LanguageContext';

const { FiMonitor, FiShield, FiTool, FiBrain, FiArrowRight } = FiIcons;

const ArticlesBanner = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const articles = [
    {
      id: 'repair',
      icon: FiMonitor,
      color: 'blue',
      path: '/reparacion-pc-la-manga'
    },
    {
      id: 'virus',
      icon: FiShield,
      color: 'red',
      path: '/eliminacion-virus-cartagena'
    },
    {
      id: 'maintenance',
      icon: FiTool,
      color: 'green',
      path: '/mantenimiento-empresarial-san-javier'
    },
    {
      id: 'courses',
      icon: FiBrain,
      color: 'purple',
      path: '/cursos-ia-murcia'
    }
  ];

  const colorClasses = {
    blue: 'from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800',
    red: 'from-red-600 to-red-700 hover:from-red-700 hover:to-red-800',
    green: 'from-green-600 to-green-700 hover:from-green-700 hover:to-green-800',
    purple: 'from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800'
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('articlesBanner.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('articlesBanner.subtitle')}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {articles.map((article, index) => (
            <motion.div
              key={article.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              onClick={() => navigate(article.path)}
              className={`cursor-pointer bg-gradient-to-br ${colorClasses[article.color]} text-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300`}
            >
              <SafeIcon icon={article.icon} className="w-12 h-12 mb-4" />
              <h3 className="text-xl font-bold mb-3">
                {t(`articlesBanner.articles.${article.id}.title`)}
              </h3>
              <p className="text-white/90 mb-4 text-sm">
                {t(`articlesBanner.articles.${article.id}.description`)}
              </p>
              <div className="flex items-center space-x-2 text-white font-semibold">
                <span>{t('articlesBanner.readMore')}</span>
                <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticlesBanner;